import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { useJump } from "../../../Components/Hooks/useJumpSection";

function Form() {
  const { targetRef } = useJump();
  const [loading, setLoading] = React.useState(false);
  const [result, setResult] = React.useState({
    show: false,
    error: "",
    sucsess: "",
  });

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  const handleClose = () => {
    setResult({
      show: false,
      error: "",
      sucsess: "",
    });
  };

  async function submitHandler(data) {
    setLoading(true);
    try {
      const res = await fetch("https://ashkandev.ir/smart_home/submit-form/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (res.ok) {
        setResult({
          show: true,
          error: "",
          sucsess: "Fetching Was Successful.",
        });
        reset();
      } else if (!res.ok) {
        setResult({
          show: true,
          error: "Something Went Wrong.",
          sucsess: "",
        });
      }
    } catch {
      setResult({
        show: true,
        error: "Something Went Wrong.",
        sucsess: "",
      });
    }
    setLoading(false);
  }

  return (
    <div
      className="bg-white py-10"
      ref={targetRef}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Dialog
        open={result.show}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Alert Fitching Form</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {result.error || result.sucsess}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={loading}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          ".MuiPaper-elevation": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
      >
        <DialogContent className="flex flex-col items-center gap-5 ">
          <CircularProgress color="white" size="80px" />
          <DialogContentText
            id="alert-dialog-description"
            color="white"
            fontSize="22px"
          >
            Wait Please
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Container
        sx={{ maxWidth: { lg: "1024px", xl: "1280px", xxl: "1536px" } }}
      >
        <Box className="flex flex-col gap-8">
          <Typography
            variant="h4"
            component="h2"
            fontSize={{ xs: 24, md: 27, lg: 30 }}
            textTransform="uppercase"
            fontWeight={200}
          >
            Learn More About <strong>MEETFUTUR Smart Homes</strong>
          </Typography>
          <Typography fontSize={{ xs: 14, md: 15, lg: 17 }}>
            MEETFUTUR homeowners enjoy personalized smart living experiences
            perfect for any home—no matter the size or budget, new construction
            or decades old. Interested in learning more about MEETFUTUR Smart
            Homes or Chime? Simply fill out this form.
          </Typography>
          <form
            className="grid grid-rows-7 md:grid-rows-3 lg:grid-rows-2 sm:grid-cols-1 md:grid-cols-6 lg:grid-cols-4 gap-5 gap-y-8 relative child:mb-4 z-30"
            onSubmit={handleSubmit(submitHandler)}
          >
            <Controller
              name="first_name"
              control={control}
              defaultValue=""
              rules={{
                required: "This Field is required",
                pattern: {
                  value: /^[A-Za-z ]*$/,
                  message: "Must Use English Characters",
                },
                minLength: {
                  value: 3,
                  message: "Most Be More Then 3 Characters",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  id="first_name"
                  label="First Name"
                  variant="outlined"
                  margin="normal"
                  error={!!errors.first_name}
                  helperText={errors.first_name?.message}
                  sx={{
                    gridColumnStart: { md: 1, lg: 1 },
                    gridColumnEnd: { md: 3, lg: 2 },
                    flexGrow: 1,
                    m: 0,
                    ".MuiFormHelperText-root": {
                      position: "absolute",
                      bottom: -20,
                    },
                  }}
                />
              )}
            />
            <Controller
              name="last_name"
              control={control}
              defaultValue=""
              rules={{
                required: "This Field is required",
                pattern: {
                  value: /^[A-Za-z ]*$/,
                  message: "Must Use English Characters",
                },
                minLength: {
                  value: 3,
                  message: "Most Be More Then 3 Characters",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  id="last_name"
                  label="Last Name"
                  variant="outlined"
                  margin="normal"
                  error={!!errors.last_name}
                  helperText={errors.last_name?.message}
                  sx={{
                    gridColumnStart: { md: 3, lg: 2 },
                    gridColumnEnd: { md: 5, lg: 3 },
                    flexGrow: 1,
                    m: 0,
                    ".MuiFormHelperText-root": {
                      position: "absolute",
                      bottom: -20,
                    },
                  }}
                />
              )}
            />
            <Controller
              name="phone"
              control={control}
              defaultValue=""
              rules={{
                required: "This Field is required",
                pattern: {
                  value: /[0-9 ]{11}$/,
                  message: "Have To Use 11 Numbers",
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  id="phone"
                  label="Phone"
                  variant="outlined"
                  margin="normal"
                  error={!!errors.phone}
                  helperText={errors.phone?.message}
                  sx={{
                    gridColumnStart: { md: 5, lg: 3 },
                    gridColumnEnd: { md: 7, lg: 4 },
                    flexGrow: 1,
                    m: 0,
                    ".MuiFormHelperText-root": {
                      position: "absolute",
                      bottom: -20,
                    },
                  }}
                />
              )}
            />
            <Controller
              name="country"
              control={control}
              defaultValue=""
              rules={{
                required: "This Field is required",
              }}
              render={({ field }) => (
                <FormControl
                  sx={{
                    gridColumnStart: { md: 1, lg: 4 },
                    gridColumnEnd: { md: 3, lg: 5 },
                    display: "block",
                    ".Mui-focused": {
                      lineHeight: "1.4375em",
                    },
                  }}
                  size="small"
                >
                  <InputLabel
                    id="country-label"
                    error={!!errors.country}
                    sx={{ lineHeight: field.value ? "1.4375em" : "2.3em" }}
                  >
                    Country
                  </InputLabel>
                  <Select
                    {...field}
                    labelId="country-label"
                    id="country"
                    label="Country"
                    error={!!errors.country}
                    size="medium"
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="Argentina">Argentina</MenuItem>
                    <MenuItem value="Australia">Australia</MenuItem>
                    <MenuItem value="Brazil">Brazil</MenuItem>
                    <MenuItem value="Canada">Canada</MenuItem>
                    <MenuItem value="China">China</MenuItem>
                    <MenuItem value="Denmark">Denmark</MenuItem>
                    <MenuItem value="Egypt">Egypt</MenuItem>
                    <MenuItem value="France">France</MenuItem>
                    <MenuItem value="Germany">Germany</MenuItem>
                    <MenuItem value="India">India</MenuItem>
                    <MenuItem value="Italy">Italy</MenuItem>
                    <MenuItem value="Iran">Iran</MenuItem>
                    <MenuItem value="Japan">Japan</MenuItem>
                    <MenuItem value="Mexico">Mexico</MenuItem>
                    <MenuItem value="Netherlands">Netherlands</MenuItem>
                    <MenuItem value="Norway">Norway</MenuItem>
                    <MenuItem value="Russia">Russia</MenuItem>
                    <MenuItem value="South Africa">South Africa</MenuItem>
                    <MenuItem value="United Kingdom">United Kingdom</MenuItem>
                    <MenuItem value="United States">United States</MenuItem>
                  </Select>
                  {!!errors.country && (
                    <FormHelperText
                      error={!!errors.country}
                      sx={{
                        position: "absolute",
                        bottom: -20,
                      }}
                    >
                      {errors.country?.message}
                    </FormHelperText>
                  )}
                </FormControl>
              )}
            />

            <Controller
              name="email"
              control={control}
              defaultValue=""
              rules={{
                required: "This Field is required",
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  id="email"
                  label="Email"
                  variant="outlined"
                  margin="normal"
                  error={!!errors.email}
                  helperText={errors.email?.message}
                  sx={{
                    gridColumnStart: { md: 3, lg: 1 },
                    gridColumnEnd: { md: 5, lg: 3 },
                    m: 0,
                    ".MuiFormHelperText-root": {
                      position: "absolute",
                      bottom: -20,
                    },
                  }}
                />
              )}
            />

            <Controller
              name="interest"
              control={control}
              defaultValue=""
              rules={{
                required: "This Field is required",
              }}
              render={({ field }) => (
                <FormControl
                  sx={{
                    gridColumnStart: { md: 5, lg: 3 },
                    gridColumnEnd: { md: 7, lg: 4 },
                    display: "block",
                    ".Mui-focused": {
                      lineHeight: "1.4375em",
                    },
                  }}
                  size="small"
                >
                  <InputLabel
                    id="interest-label"
                    error={!!errors.interest}
                    sx={{ lineHeight: field.value ? "1.4375em" : "2.3em" }}
                  >
                    Your Interest
                  </InputLabel>
                  <Select
                    {...field}
                    labelId="interest-label"
                    id="interest"
                    label="Your Interest"
                    error={!!errors.interest}
                    size="medium"
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="smart-home-os">Smart Home OS</MenuItem>
                    <MenuItem value="whole-home">Whole Home</MenuItem>
                    <MenuItem value="smart-lighting">Smart Lighting</MenuItem>
                    <MenuItem value="home-security">Home Security</MenuItem>
                    <MenuItem value="intercom-anywhere">
                      Intercom Anywhere
                    </MenuItem>
                    <MenuItem value="home-theater">Home Theater</MenuItem>
                    <MenuItem value="multi-room-audio">
                      Multi-Room Audio
                    </MenuItem>
                    <MenuItem value="universal-remote">
                      Universal Remote
                    </MenuItem>
                    <MenuItem value="voice-control">Voice Control</MenuItem>
                    <MenuItem value="4sight-services">4Sight Services</MenuItem>
                    <MenuItem value="assist">Assist</MenuItem>
                    <MenuItem value="connect">Connect</MenuItem>
                  </Select>
                  {!!errors.interest && (
                    <FormHelperText
                      error={!!errors.interest}
                      sx={{
                        position: "absolute",
                        bottom: -20,
                      }}
                    >
                      {errors.interest?.message}
                    </FormHelperText>
                  )}
                </FormControl>
              )}
            />

            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{
                gridColumnStart: { md: 1, lg: "auto" },
                gridColumnEnd: { md: 3, lg: "auto" },
                py: 0,
                flexGrow: 1,
              }}
            >
              Submit
            </Button>
          </form>
        </Box>
      </Container>
    </div>
  );
}

export default Form;
